// "https://github.com/Allen-1998/pinia-auto-refs"
/* eslint-disable */
/* prettier-ignore */
// @ts-nocheck
import type { AutoToRefs, ToRef } from 'vue'

import chatStore from '@/store/chat'
import commonStore from '@/store/common'
import eventsStore from '@/store/events'
import labStore from '@/store/lab'
import localeStore from '@/store/locale'
import operatorStore from '@/store/operator'
import userStore from '@/store/user'

import store from '@/store'

declare module 'vue' {
  export type AutoToRefs<T> = {
    [K in keyof T]: T[K] extends Function ? T[K] : ToRef<T[K]>
  }
}

const storeExports = {
  chat: chatStore,
  common: commonStore,
  events: eventsStore,
  lab: labStore,
  locale: localeStore,
  operator: operatorStore,
  user: userStore,
}

export function useStore<T extends keyof typeof storeExports>(storeName: T) {
  const targetStore = storeExports[storeName](store)
  const storeRefs = storeToRefs(targetStore)
  return { ...targetStore, ...storeRefs } as unknown as AutoToRefs<ReturnType<typeof storeExports[T]>>
}
